import classNames from "classnames";
import styles from "./CreditOffersGroup.module.scss";
import { CreditIllustration } from "../../../../../types/cobeTypes";

type Props = {
  creditOfferGroup: CreditIllustration[];
  type: "IFC" | "IBC";
};

export const CreditOffersGroup = ({ creditOfferGroup, type }: Props) => {
  const isList = creditOfferGroup.length > 1;

  interface CreditOfferCardProps {
    creditOffer: CreditIllustration;
    index: number;
  }

  const CreditOfferCard = ({ creditOffer, index }: CreditOfferCardProps) => {
    const {
      financialProductType,
      creditRate,
      monthlyRepayment,
      creditTerm,
      creditAmount,
      totalRepaymentAmount,
    } = creditOffer;

    return (
      <div
        className={styles.creditOfferCard}
        data-testid={`credit-offer-card-${financialProductType}`}
      >
        {!isList && (
          <p
            className={styles.creditOfferCard__title}
            data-testid="credit-offer-card-title"
          >
            <span>{creditRate.display} APR</span>
          </p>
        )}
        <p className={styles.creditOfferCard__subtitle}>
          {index === 0 ? "Pay " : "Or pay "}
          <span>{monthlyRepayment.display} per month</span> over{" "}
          <span>{creditTerm.display}</span>
        </p>
        <p className={styles.creditOfferCard__content}>
          Product cost: <span>{creditAmount.display}</span>
        </p>
        {financialProductType === "IBC" && (
          <p className={styles.creditOfferCard__content}>
            Total amount payable: <span>{totalRepaymentAmount.display}</span>
          </p>
        )}
        <p className={styles.creditOfferCard__content}>
          Interest rate:{" "}
          <span>
            {creditRate.display} APR
            {financialProductType === "IBC" && ` Representative`}
          </span>
          {` (Fixed)`}
        </p>
      </div>
    );
  };

  const isListClass = isList ? "multiOffer" : "soloOffer";

  return (
    <div
      data-testid={`credit-offer-group-${type}`}
      className={classNames(
        styles.creditOffersGroup,
        styles[`creditOffersGroup__${type}`],
        styles[`creditOffersGroup__${isListClass}`],
      )}
    >
      {isList && (
        <p
          data-testid="credit-offer-group-title"
          className={classNames(
            styles.creditOfferCard__title,
            styles.creditOffersGroup__multiOffer__title,
          )}
        >
          <span>
            {
              // @ts-ignore
              creditOfferGroup[0].creditRate.display
            }{" "}
            APR
          </span>
        </p>
      )}
      {creditOfferGroup.map((offer, index) => (
        <CreditOfferCard key={index} creditOffer={offer} index={index} />
      ))}
    </div>
  );
};
